import React, { useState } from "react";
import styled from "styled-components";
import configs from "constants/configs";
import browserHistory from "utils/history";
import { pushNotification } from "utils/notifications";
import TatToanChoDuyetApi from "service/tatToanChoDuyetApi";

// Man hinh dich khi click 1 thong bao Morman (hien tai chi co nghiep vu tat toan cho duyet)
const URL_TAT_TOAN_CHO_DUYET = "/trang-chu/bao-cao/tat-toan-cho-duyet.aspx";

// Chi chuyen sang man Tat toan cho duyet khi tai khoan co quyen "tattoanchoduyet",
// vi trang do render rong neu khong co quyen (xem components/BaoCao/TatToanChoDuyet).
const chuyenSangTatToanChoDuyet = () => {
  TatToanChoDuyetApi.phanQuyenTatToanChoDuyet()
    .then((response) => {
      if (response && response.data && response.data.tattoanchoduyet) {
        browserHistory.push(URL_TAT_TOAN_CHO_DUYET);
      } else {
        pushNotification(
          "Bạn không có quyền truy cập màn hình Tất toán chờ duyệt.",
          "error",
          "TOP_CENTER",
          2000,
        );
      }
    })
    .catch(() => {
      pushNotification(
        "Không kiểm tra được quyền truy cập. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        2000,
      );
    });
};
const Tab = styled.button`
  font-size: 13px;
  padding: 8px 10px;
  cursor: pointer;
  opacity: 0.6;
  background: white;
  border: 0;
  outline: 0;
  border-bottom: 2px solid #eeeeee;
  white-space: nowrap;
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #056569;
    opacity: 1;
    color: #056569;
  `}
`;
const ButtonGroup = styled.div`
  display: flex;
`;
// Nhãn tròn hiển thị số lượng thông báo trên mỗi tab
const Badge = styled.span`
  display: inline-block;
  min-width: 18px;
  margin-left: 5px;
  padding: 1px 5px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  background: ${({ highlight }) => (highlight ? "#e74c3c" : "#b0b8b8")};
`;
// Nút lọc theo trạng thái đọc (chỉ dùng cho tab Morman)
const FilterChip = styled.button`
  font-size: 12px;
  padding: 3px 10px;
  margin-right: 6px;
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid #d5dbdb;
  background: ${({ active }) => (active ? "#056569" : "#ffffff")};
  color: ${({ active }) => (active ? "#ffffff" : "#6b7573")};
  outline: 0;
`;
// Nút "Đánh dấu tất cả đã đọc"
const LinkAction = styled.button`
  font-size: 12px;
  padding: 3px 0;
  margin-left: auto;
  cursor: pointer;
  border: 0;
  background: transparent;
  color: #056569;
  text-decoration: underline;
  outline: 0;
  &:disabled {
    color: #b0b8b8;
    cursor: default;
    text-decoration: none;
  }
`;
// NgayTao tra ve dang ISO khong kem mui gio (vd 2026-09-09T14:32:11) => hieu la gio may client
const dinhDangThoiGian = (ngayTao) => {
  if (!ngayTao) return "";
  const date = new Date(ngayTao);
  if (isNaN(date.getTime())) return "";
  const hai = (so) => String(so).padStart(2, "0");
  return `${hai(date.getDate())}/${hai(date.getMonth() + 1)}/${date.getFullYear()} ${hai(date.getHours())}:${hai(date.getMinutes())}`;
};
const types = ["Morman", "Chợ tín dụng", "Hệ thống"];
// TrangThai = 0 là chưa đọc (xem backend thong-bao/danh-sach-thong-bao-moi)
const CHUA_DOC = 0;
const boLocs = [
  { key: "tatca", label: "Tất cả" },
  { key: "chuadoc", label: "Chưa đọc" },
  { key: "dadoc", label: "Đã đọc" },
];

export const TabThongBao = ({
  lstThongBaoMorman,
  lstThongBaoHeThong,
  lstChoTinDung,
  isRoleChoTinDung,
  urlChoTinDung,
  urlError,
  onDanhDauDaDoc,
  onDanhDauTatCaDaDoc,
}) => {
  const [active, setActive] = useState(types[0]);
  const [boLoc, setBoLoc] = useState("chuadoc");

  const lstMorman = lstThongBaoMorman || [];
  const lstHeThong = lstThongBaoHeThong || [];
  const lstChoTinDungList =
    lstChoTinDung && lstChoTinDung.List ? lstChoTinDung.List : [];

  const laChuaDoc = (item) => Number(item.TrangThai) === CHUA_DOC;
  const soChuaDoc = lstMorman.filter(laChuaDoc).length;
  const soDaDoc = lstMorman.length - soChuaDoc;

  // Danh sách Morman sau khi lọc theo trạng thái đọc
  const lstMormanHienThi = lstMorman.filter((item) => {
    if (boLoc === "chuadoc") return laChuaDoc(item);
    if (boLoc === "dadoc") return !laChuaDoc(item);
    return true;
  });

  const soLuongTheoTab = (type) => {
    if (type === "Morman") return soChuaDoc;
    if (type === "Chợ tín dụng") return lstChoTinDungList.slice(0, 4).length;
    return lstHeThong.length;
  };

  const soLuongTheoBoLoc = (key) => {
    if (key === "chuadoc") return soChuaDoc;
    if (key === "dadoc") return soDaDoc;
    return lstMorman.length;
  };

  const khongCoDuLieu =
    (active === "Morman" && lstMormanHienThi.length === 0) ||
    (active === "Chợ tín dụng" && lstChoTinDungList.length === 0) ||
    (active === "Hệ thống" && lstHeThong.length === 0);

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <span
            style={{
              paddingLeft: "20px",
              fontSize: "18px",
              fontWeight: "bold",
              color: "black",
            }}
          >
            Thông báo
          </span>
          {soChuaDoc > 0 && (
            <span
              style={{
                marginLeft: "8px",
                fontSize: "12px",
                color: "#e74c3c",
                fontWeight: "bold",
              }}
            >
              {soChuaDoc} chưa đọc
            </span>
          )}
        </div>
        <div className="col-lg-12" style={{ marginLeft: "10px" }}>
          <ButtonGroup>
            {types.map((type) => (
              <Tab
                key={type}
                active={active === type}
                onClick={() => setActive(type)}
                style={{ paddingLeft: "10px" }}
              >
                <b>{type}</b>
                <Badge highlight={type === "Morman" && soChuaDoc > 0}>
                  {soLuongTheoTab(type)}
                </Badge>
              </Tab>
            ))}
          </ButtonGroup>
        </div>
        {active === "Morman" && (
          <div
            className="col-lg-12"
            style={{
              marginLeft: "10px",
              marginTop: "8px",
              display: "flex",
              alignItems: "center",
              paddingRight: "20px",
            }}
          >
            {boLocs.map((item) => (
              <FilterChip
                key={item.key}
                active={boLoc === item.key}
                onClick={() => setBoLoc(item.key)}
                type="button"
              >
                {item.label} ({soLuongTheoBoLoc(item.key)})
              </FilterChip>
            ))}
            <LinkAction
              style={{ marginLeft: "initial" }}
              type="button"
              disabled={soChuaDoc === 0}
              onClick={() => {
                if (typeof onDanhDauTatCaDaDoc === "function")
                  onDanhDauTatCaDaDoc();
              }}
            >
              Read
            </LinkAction>
          </div>
        )}
        <div className="col-lg-12">
          {active === "Morman" &&
            lstMormanHienThi.map((item) => {
              const chuaDoc = laChuaDoc(item);
              return (
                <a
                  href="#"
                  key={item.ID}
                  onClick={(evt) => {
                    evt.preventDefault();
                    if (chuaDoc && typeof onDanhDauDaDoc === "function")
                      onDanhDauDaDoc(item.ID);
                    chuyenSangTatToanChoDuyet();
                  }}
                >
                  <div
                    class="media"
                    style={{
                      padding: "0.5rem",
                      paddingLeft: "1rem",
                      background: chuaDoc ? "#f2fbfa" : "transparent",
                      borderLeft: chuaDoc
                        ? "3px solid #00B69B"
                        : "3px solid transparent",
                    }}
                  >
                    {/* <div class="media-left align-self-center">
                    <i class="la la-exclamation-circle"></i>
                  </div> */}
                    <div class="media-body">
                      <h6
                        class="media-heading blue darken-1"
                        style={{
                          color: "#00B69B",
                          fontSize: "13px",
                          marginBottom: "3px",
                        }}
                      >
                        <strong>{item.TieuDe}</strong>
                        {chuaDoc && (
                          <span
                            style={{
                              marginLeft: "6px",
                              fontSize: "10px",
                              fontWeight: "bold",
                              color: "#e74c3c",
                            }}
                          >
                            ● Mới
                          </span>
                        )}
                      </h6>
                      <p
                        class="notification-text font-small-3 text-muted"
                        style={{
                          fontSize: "12px",
                          lineHeight: "1.5",
                          marginBottom: "0px",
                        }}
                      >
                        {item.NoiDung}
                      </p>
                      {dinhDangThoiGian(item.NgayTao) && (
                        <span
                          style={{
                            display: "block",
                            marginTop: "3px",
                            fontSize: "11px",
                            color: "#9aa5a5",
                          }}
                        >
                          {dinhDangThoiGian(item.NgayTao)}
                        </span>
                      )}
                    </div>
                  </div>
                </a>
              );
            })}
          {active === "Chợ tín dụng" &&
            lstChoTinDungList.slice(0, 4).map((item, index) => {
              return (
                <a
                  href={isRoleChoTinDung ? urlChoTinDung : urlError}
                  key={index}
                >
                  <div class="media">
                    <div class="media-left align-self-center">
                      <i class="la la-exclamation-circle"></i>
                    </div>
                    <div class="media-body">
                      <h6
                        class="media-heading blue darken-1"
                        style={{ fontSize: "13px" }}
                      >
                        Khách hàng <strong>{item.HoVaTen}</strong> vừa đăng ký
                        vay ở chợ thông tin tín dụng
                      </h6>
                    </div>
                  </div>
                </a>
              );
            })}
          {active === "Hệ thống" &&
            lstHeThong.map((item) => {
              let { NotificationID, Title, Description } = item;
              return (
                <a
                  key={NotificationID}
                  href={
                    configs.mormanServer +
                    `/trang-chu/quan-tri-he-thong/thong-bao.aspx?id=${NotificationID}&time=${new Date().getTime()}`
                  }
                >
                  <div class="media">
                    <div class="media-left align-self-center">
                      <i class="la la-exclamation-circle"></i>
                    </div>
                    <div class="media-body">
                      <h6
                        class="media-heading blue darken-1"
                        style={{ fontSize: "13px", marginBottom: "3px" }}
                      >
                        <strong>{Title}</strong>
                      </h6>
                      <p
                        class="notification-text font-small-3 text-muted"
                        style={{ fontSize: "12px", lineHeight: "1.5" }}
                      >
                        {Description}
                      </p>
                    </div>
                  </div>
                </a>
              );
            })}
          {khongCoDuLieu && (
            <>
              <div style={{ height: "200px", textAlign: "center" }}>
                <img
                  src="/app-assets/images/ThongBaoNoData.png"
                  alt=""
                  style={{ width: 200, marginTop: "5px" }}
                />
                <br />
                <b style={{ fontSize: "13px" }}>
                  {active === "Morman" && boLoc === "chuadoc"
                    ? "Không có thông báo chưa đọc"
                    : active === "Morman" && boLoc === "dadoc"
                      ? "Không có thông báo đã đọc"
                      : "Không có thông báo"}
                </b>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
